import { useIsAdminOrDev } from "@/auth/roles";

export const useIsDownloadsEnabled = () => {
  return useIsAdminOrDev();
};

export const useIsModelPriceEnabled = () => {
  return useIsAdminOrDev();
};
